<template>
  <Page>
    <template #title>Справочники</template>
    <BaseNavigation class="mb-6" :items="menu" />

    <PageContent>
      <BaseTable
        :columns="columns"
        :items="conditionList.items"
        :is-loading="isLoading"
      >
        <template #header-life_situation="column">
          {{ column.name }}
          <LazySelect
            class="filter-select mt-1"
            label="name"
            v-model="filter.lifeSituation"
            :clearable="true"
            :source="loadLifeSituationsSelect"
            @input="changeFilter"
          />
        </template>
      </BaseTable>
      <BasePagination
        class="my-6"
        :pagination="conditionList.pagination"
        @paginate="onPaginate"
      />
    </PageContent>
  </Page>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

  import isEqual from 'lodash/isEqual';
  import Client from '@/classes/Api/Client';

  import Page from '@/components/layouts/main/page';
  import BaseTable from '@/components/global/base-table';
  import LazySelect from '@/components/global/lazy-select';
  import BasePagination from '@/components/global/base-pagination';
  import BaseNavigation from '@/components/global/base-navigation';
  import PageContent from '@/components/layouts/main/page/PageContent';

  export default {
    name: 'ConditionListPage',

    components: {
      Page,
      BaseTable,
      LazySelect,
      PageContent,
      BaseNavigation,
      BasePagination,
    },

    data() {
      return {
        isLoading: false,

        filter: {
          lifeSituation: null,
        },

        columns: [
          {
            name: 'Номер',
            slug: 'id',
            headClasses: ['col-id'],
          },
          {
            name: 'Жизненная ситуация',
            slug: 'life_situation',
            headClasses: ['col-life_situation'],
          },
          {
            name: 'Название',
            slug: 'name',
            headClasses: ['col-name'],
          },
        ],
      };
    },

    computed: {
      ...mapGetters('Auth', ['hasRole']),
      ...mapState('Dictionary', ['conditionList']),

      menu() {
        if (this.hasRole('operator')) {
          return [
            {
              name: 'Заявки',
              link: 'operator.dictionary.list',
            },
            {
              name: 'Условия',
              link: 'operator.condition.list',
            },
          ];
        }

        if (this.hasRole('head')) {
          return [
            {
              name: 'Условия',
              link: 'head.condition.list',
            },
          ];
        }

        return [
          {
            name: 'Заявка на добавление',
            link: 'dictionary.request',
          },
          {
            name: 'Просмотр заявок',
            link: 'dictionary.list',
          },
          {
            name: 'Условия',
            link: 'condition.list',
          },
        ];
      },
    },

    created() {
      this.isLoading = true;

      Client.getConditionListFilter(this.getQueryFilter()).then((response) => {
        this.bindFilter(response.data);
      });

      this.$store
        .dispatch('Dictionary/loadConditionList', this.getQueryFilter())
        .finally(() => {
          this.isLoading = false;
        });
    },

    destroyed() {
      this.$store.dispatch('Dictionary/clearConditionList');
    },

    beforeRouteUpdate(to, from, next) {
      this.isLoading = true;

      this.$store
        .dispatch('Dictionary/loadConditionList', this.getQueryFilter(to.query))
        .finally(() => {
          this.isLoading = false;
        });

      next();
    },

    methods: {
      loadLifeSituationsSelect() {
        return Client.getLifeSituations().then((response) => {
          return response.data;
        });
      },

      bindFilter(data) {
        this.filter = {
          lifeSituation: data.life_situation,
        };
      },

      changeFilter() {
        let curQuery = this.$route.query;
        let newQuery = Object.assign({}, curQuery, {
          page: 1,
          life_situation_id: this.filter.lifeSituation?.id || null,
        });

        if (!isEqual(curQuery, newQuery)) {
          this.$router.push({
            query: newQuery,
          });
        }
      },

      getQueryFilter(query) {
        query = query || this.$route.query;
        return {
          page: query.page || 1,
          life_situation_id: query.life_situation_id || null,
        };
      },

      onPaginate(page) {
        this.$router.push({
          query: Object.assign(this.getQueryFilter(), {
            page: page,
          }),
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep {
    .col-id {
      vertical-align: top;
      width: rem(100px);
    }
    .col-name {
      vertical-align: top;
    }
    .col-life_situation {
      vertical-align: top;
      width: rem(300px);
    }
  }
</style>
